module.exports = __webpack_public_path__ + "img/9788997798001.e0e1459c.jpg";